'use client'

import { UserReferralStats } from '@repo/services'
import {
  Button,
  Col,
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
  Separator,
  Typography,
} from '@repo/ui/components'

import { useState } from 'react'

import { InviteTable } from './invite-table'
import { InviteDetails } from './invite-details'
import { useTranslate } from '@repo/shared/hooks'
import { InviteDetailsNoKyc } from './invite-details-no-kyc'

interface InviteDetailsDialogProps extends UserReferralStats {
  children: React.ReactNode
}

export const InviteDetailsDialog = (props: InviteDetailsDialogProps) => {
  const { children, ...referralStatsData } = props
  const { userID, maskedPhone, maskedEmail } = props
  const [open, setOpen] = useState(false)
  const { t } = useTranslate()
  const title = maskedPhone ? maskedPhone?.replace('+98', '0') : maskedEmail

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalTrigger asChild>{children}</ModalTrigger>
      <ModalContent className='sm:max-w-[470px]'>
        <ModalHeader>
          <ModalTitle className='ltr text-center'>
            <Col className='gap-2xs'>
              <Typography size='xs' color='text-neutral-surface-60'>
                {t('inviteTable_header_invited_title')}
              </Typography>
              <Typography size='md' weight='bold'>
                {title}
              </Typography>
            </Col>
          </ModalTitle>
        </ModalHeader>
        <div className='flex  flex-col max-h-[600px] overflow-y-auto'>
          {referralStatsData.kyc && <InviteDetails item={referralStatsData} />}
          {!referralStatsData.kyc && (
            <InviteDetailsNoKyc item={referralStatsData} />
          )}
          {referralStatsData.kyc && <Separator />}
          {referralStatsData.kyc && (
            <InviteTable userID={userID} forceMobileStyle={true} />
          )}
        </div>
        <div className='flex  flex-col '>
          <Button
            variant='ghost'
            width='full'
            size='md'
            color='neutral'
            onClick={() => setOpen(false)}
          >
            {t('common_back')}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  )
}
